// Module
var code = `<svg xmlns="http://www.w3.org/2000/svg" width="13.455" height="8" viewBox="0 0 13.455 8"> <path d="M13.455 1.273 12.182 0 6.727 5.454 1.273 0 0 1.273 6.727 8z"/> </svg> `;
// Exports
var _module_exports =code;;
var path = 'icons/arrow_down.svg';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;